// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-tabs ion-tab-bar ion-tab-button {
  --background: var(--ion-color-light);
  --color: var(--ion-color-medium);
  --color-selected: var(--ion-color-dark);
}
ion-tabs ion-tab-bar ion-tab-button ion-icon {
  font-size: 1.5rem;
}
ion-tabs ion-fab ion-fab-button {
  --background: linear-gradient(to bottom, #015b33, #219d66, #00ff95);
  margin-bottom: 2vh;
}
ion-tabs ion-fab ion-fab-button ion-icon {
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAEQ;EACI,oCAAA;EACA,gCAAA;EACA,uCAAA;AADZ;AAEY;EACI,iBAAA;AAAhB;AAKQ;EACI,mEAAA;EAEA,kBAAA;AAJZ;AAKY;EACI,eAAA;AAHhB","sourcesContent":["ion-tabs {\r\n    ion-tab-bar {\r\n        ion-tab-button {\r\n            --background: var(--ion-color-light);\r\n            --color: var(--ion-color-medium);\r\n            --color-selected: var(--ion-color-dark);\r\n            ion-icon {\r\n                font-size: 1.5rem;\r\n            }           \r\n        }\r\n    }\r\n    ion-fab {\r\n        ion-fab-button {\r\n            --background: linear-gradient(to bottom, #015b33, #219d66, #00ff95);\r\n            //--background: linear-gradient(to bottom, #C13584, #E1306C, #FD1D1D, #F56040, #F77737, #FCAF45, #FFDC80);\r\n            margin-bottom: 2vh;\r\n            ion-icon {\r\n                font-size: 2rem;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
